import React from 'react';
import { ArrowRight as ArrowRightIcon, Leaf as LeafIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const urgencyItems = [{
  image: 'https://cdn.magicpatterns.com/uploads/8morGjpgJNNbZ9Ky3h3k3H/Desayunos_4.jpg',
  alt: 'Eggs, avocado, berries, and seeded yogurt',
  text: '🔥 LAUNCH PRICE ENDS SOON — Get 50 recipes + 5 bonuses for $19.99 before it goes up to $47.00'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/6Pz6RmXdU2tshAiFVyCDe2/Desayunos_5.jpg',
  alt: 'Strawberry and blueberry yogurt parfait',
  text: "⏰ This price expires soon — grab it before it's gone"
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2252cxXo9BdfVTicaFto2E/Desayunos_2.jpg',
  alt: 'Raspberry yogurt parfait held in a hand',
  text: '✨ 21 Days of Radiant Mornings — More Energy · Less Bloating · Flatter Belly in 21 days'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ezcCqfPxTks7P9KcjKJE7p/Desayunos_1.jpg',
  alt: 'Yogurt bowl with banana, berries, and granola',
  text: '🛡️ 7-Day Money-Back Guarantee — Zero risk, all reward'
}];
export function Hero() {
  return <>
      <div className="sticky top-0 z-50 flex h-14 items-center overflow-hidden border-b border-cream/15 bg-forest text-sm font-bold text-cream shadow-lg" data-id="element-73">
        <div className="min-w-0 flex-1 overflow-hidden" aria-label="Limited-time offer details" data-id="element-74">
          <div className="urgency-marquee-track flex w-max" data-id="element-75">
            {[false, true].map(isDuplicate => <div key={isDuplicate ? 'duplicate' : 'primary'} className="flex shrink-0 items-center" aria-hidden={isDuplicate} data-id="element-76">
                {urgencyItems.map(({
              image,
              alt,
              text
            }, index) => <div key={text} className="flex shrink-0 items-center whitespace-nowrap pr-10" data-id="element-77">
                    <img src={image} alt={isDuplicate ? '' : alt} className="urgency-marquee-image mx-3 h-9 w-9 rounded-md object-cover" style={{
                animationDelay: `-${index * 1.2}s`
              }} data-id="element-78" />
                    <span data-id="element-79">{text}</span>
                  </div>)}
              </div>)}
          </div>
        </div>

        <div className="flex h-full shrink-0 items-center border-l border-cream/20 bg-forest px-3 sm:px-4" data-id="element-80">
          <span className="hidden text-cream/75 sm:inline" data-id="element-81">Expires in:</span>
          <span className="text-cream/75 sm:hidden" data-id="element-82">Expires:</span>
          <time className="ml-2 rounded bg-terracotta px-2 py-1 font-mono text-sm font-extrabold tabular-nums text-white" aria-label="Offer expires in 00:00" data-id="element-83">
            00:00
          </time>
        </div>
      </div>

      <header className="border-b border-forest/10 bg-cream" data-id="element-84">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-5 lg:px-8" data-id="element-85">
          <a href="#top" className="flex items-center gap-2 text-lg font-bold tracking-tight text-forest" aria-label="Edad Radiante home" data-id="element-86">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-terracotta text-white" data-id="element-87">
              <LeafIcon size={17} data-id="element-88" />
            </span>
            Edad Radiante
          </a>
          <a href="#offer" className="hidden text-sm font-bold text-forest underline decoration-terracotta decoration-2 underline-offset-4 sm:block" data-id="element-89">
            Get the guide
          </a>
        </div>
      </header>

      <main id="top" className="bg-cream" data-id="element-90">
        <section className="mx-auto grid max-w-6xl items-center gap-9 px-5 py-12 sm:py-14 lg:grid-cols-[1.08fr_.92fr] lg:gap-14 lg:px-8 lg:py-16" data-id="element-91">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-92">
            <div className="mb-6 flex items-center gap-3 text-terracotta" data-id="element-93">
              <span className="h-px w-8 bg-terracotta/60" aria-hidden="true" data-id="element-94" />
              <LeafIcon size={19} strokeWidth={2.5} aria-hidden="true" data-id="element-95" />
              <p className="text-xl font-extrabold uppercase tracking-[0.08em] sm:text-2xl" data-id="element-96">
                21 Days of Radiant Mornings
              </p>
            </div>

            <h1 className="max-w-2xl font-serif text-3xl leading-[1.16] tracking-tight text-forest sm:text-4xl lg:text-[2.65rem]" data-id="element-97">
              <span className="block" data-id="element-98">
                You sleep 8 hours and still wake up exhausted.
              </span>
              <span className="mt-3 block" data-id="element-99">
                You eat well and still gain weight.
              </span>
              <span className="mt-3 block" data-id="element-100">
                Your body isn&apos;t broken — it just needs a breakfast plan
                built for menopause.
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-7 text-forest/80 sm:text-lg sm:leading-8" data-id="element-101">
              21 Days of Radiant Mornings is the hormone-friendly breakfast plan
              that wakes up your energy, reduces bloating, and brings you back
              to yourself — no impossible diets, no starving, no guilt.
            </p>

            <a href="https://pay.hotmart.com/N106717501L" className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-terracotta px-6 py-5 text-center text-sm font-extrabold tracking-wide text-white shadow-lg shadow-terracotta/20 transition hover:bg-[#a84a35] focus:outline-none focus:ring-4 focus:ring-terracotta/30 sm:w-auto" data-id="element-102">
              YES — START MY 21 DAYS OF RADIANT MORNINGS{' '}
              <ArrowRightIcon size={18} data-id="element-103" />
            </a>
            <p className="mt-4 text-sm font-semibold leading-6 text-forest/75" data-id="element-104">
              ✓ Instant access · ✓ Secure checkout · ✓ 7-day money-back
              guarantee
            </p>
          </motion.div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative mx-auto w-full max-w-[25rem] lg:max-w-[28rem]" data-id="element-105">
            <div className="absolute -left-3 -top-3 h-full w-full rounded-[2rem] border border-terracotta/45 sm:-left-4 sm:-top-4" aria-hidden="true" data-id="element-106" />
            <img className="relative w-full rounded-[2rem] object-cover shadow-xl shadow-forest/15" src="https://cdn.magicpatterns.com/uploads/rDuBQ5G6CCAof6oKQMrnb9/eBook_Principal.png" alt="21 Days of Radiant Mornings digital guide" data-id="element-107" />
          </motion.figure>
        </section>
      </main>
    </>;
}